// Path: src\Components\Rewards\Transactions.jsx
import React, { useCallback, useEffect, useRef, useState } from "react";
import BuyBoxBtn from "../CommonFields/BuyBoxBtn";
import { useNavigate } from "react-router";
import { transactionList } from "../../api/transaction.api";
import { url } from "../../config/url";
import moment from "moment";
import ListLoader from "../Common/ListLoader";
import coin from "../../assets/images/coin.png";
import gems from "../../assets/images/gems.png";
const Transactions = ({ type }) => {
  const data = [
    {
      status: "winnings",
      date: "20 oct 2024, 9:38",
      transId: "25323536242",
      gameName: "free fire max",
      transType: "added",
    },
    {
      status: "winnings",
      date: "20 oct 2024, 9:38",
      transId: "25323536242",
      gameName: "free fire max",
      transType: "deduct",
    },
  ];

  const naviagte = useNavigate();
  const [transactionListAry, setTransactionList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordPerPage, setRecordPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setCurrentPage(1);
    setTotalPages(1);
  }, [type]);

  useEffect(() => {
    if (currentPage <= totalPages) loadMore();
  }, [currentPage]);

  const loadMore = async () => {
    fetchTransactions();
  };

  const observer = useRef();
  const lastPostElementRef = useCallback(
    async (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setCurrentPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading]
  );

  const fetchTransactions = async () => {
    setLoading(true);
    try {
      let data = {
        pagination: {
          pageNo: currentPage,
          recordPerPage: recordPerPage,
          sortBy: "createdAt",
          sortDirection: "asc",
        },
        search: {
          currencyType: type, // "coin / gems"
        },
      };

      const res = await transactionList(data);
      setLoading(false);
      if (res?.success && res?.data) {
        let list = [];
        if (res?.data && res?.data?.length > 0) {
          for (let i = 0; i < res?.data?.length; i++) {
            let obj = { ...res?.data?.[i] };
            obj.index = i + 1;
            list.push(obj);
          }
        }

        if (currentPage == 1) {
          setTransactionList(list);
        } else {
          setTransactionList([...transactionListAry, ...list]);
        }
        setTotalPages(res?.totalPages);
      } else {
        setTransactionList([]);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <div className="transactions">
      {transactionListAry?.length > 0
        ? transactionListAry?.map((item, index) => {
            return (
              <div
                className="trans-box  mt-4 position-relative"
                key={index}
                ref={
                  transactionListAry?.length === index + 1
                    ? lastPostElementRef
                    : null
                }
              >
                <div className="border-white">
                  <div className="d-flex justify-content-between align-items-center">
                    <h4 className="mb-0 text-ellipsis">
                      {item?.paymentType?.length > 14 ? (
                        <marquee>{item?.paymentType}</marquee>
                      ) : (
                        item?.paymentType
                      )}
                      {/* {item?.paymentType} */}
                    </h4>
                    <p className="mb-0 f-12">
                      {moment(item?.createdAt).format("DD/MM/YYYY, hh:mm a")}
                    </p>
                  </div>
                  <div className="d-flex justify-content-between mt-2">
                    <div>
                      <h4
                        className="f-12 mb-0 f-bold"
                        style={{ letterSpacing: "1.5px" }}
                      >
                        {item?.transactionUniqueID?.length > 20 ? (
                          <marquee>{item?.transactionUniqueID}</marquee>
                        ) : (
                          item?.transactionUniqueID
                        )}
                        {/* {item?.transactionUniqueID} */}
                      </h4>
                      <p className="f-12 mb-0 font-light">transaction id</p>
                    </div>
                    {item?.details?.subtitle && item?.details?.title && (
                      <div>
                        <h4 className="mb-0 f-12">
                          {item?.details?.title?.length > 13 ? (
                            <marquee>{item?.details?.title}</marquee>
                          ) : (
                            item?.details?.title
                          )}
                          {/* {item?.details?.title} */}
                        </h4>
                        <p className="f-12 mb-0 font-light game">
                        {item?.details?.subtitle?.length > 10 ? (
                            <marquee>{item?.details?.subtitle}</marquee>
                          ) : (
                            item?.details?.subtitle
                          )}
                          {/* {item?.details?.subtitle} */}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
                <div className="back-card position-absolute">
                  <div
                    className={`${
                      item?.transactionType == "credit" ? "bg-green bg-green-v2" : "bg-red"
                    } gems d-flex`}
                    // style={{alignItems:"center",flexDirection: "column"}}
                    style={{alignItems:"center",justifyContent: "space-around"}}
                  >
                    {item?.amount?.length > 4 ? (
                                      <marquee>
                                        {item?.amount}
                                      </marquee>
                                    ) : (
                                        item?.amount
                                    )} 
                    {/* {item?.amount} */}
                    <br />
                   <span> <div className="bg-green-ellipsis" style={{width:"2.5ch"}}>
                      <div style={{width:"20px",height:"100%"}}>
                       
    <img 
      src={`${url.IMAGE_URL}${item.currencyImg}`} 
      alt=" " 
      style={{ width: "100%", height: "100%", objectFit: "contain" }} 
    />
                      </div>
                    </div></span>
                  </div>
                </div>
              </div>
            );
          })
        : !loading && (
            <div className="w-100 d-flex justify-content-center no-rec-found-transaction">
              <span className="text-center">No data found</span>
            </div>
          )}

      {loading && (
        <div className="w-100 d-flex justify-content-center">
          {" "}
          <ListLoader />
        </div>
      )}
    </div>
  );
};

export default Transactions;
